import { create } from 'zustand';

export interface SnackbarMessage {
  id: string;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  snackbars: SnackbarMessage[];
  showSnackbar: (message: string, severity?: SnackbarMessage['severity']) => void;
  dismissSnackbar: (id: string) => void;
}

export const useUiStore = create<UiState>()((set) => ({
  sidebarOpen: true,
  toggleSidebar: () => {
    set((state) => ({ sidebarOpen: !state.sidebarOpen }));
  },
  setSidebarOpen: (open) => {
    set({ sidebarOpen: open });
  },

  snackbars: [],
  showSnackbar: (message, severity = 'info') => {
    const id = crypto.randomUUID();
    set((state) => ({ snackbars: [...state.snackbars, { id, message, severity }] }));
  },
  dismissSnackbar: (id) => {
    set((state) => ({ snackbars: state.snackbars.filter((snackbar) => snackbar.id !== id) }));
  },
}));
